export type DeviceStatus = 'connected' | 'disconnected' | 'communicating' | 'commissioned' | 'decommissioned' | 'Register' | 'CertificateAvailable' | 'DownloadComplete' | 'PublishReady' | 'Pending' | 'Failed' | 'Deregistered' | 'AdminApprovalPending' | 'AdminApproved' | 'AdminRejected';
export type DeviceStatusName = any
export type DeviceType = 'welding_device' | 'coating_device';
export type DeviceTypeName = any
export type WeldType = 'm500' | 'coating' | string; // Allow for other weld types
export const WeldTypeNames:any = {
  'm500': 'M-500',
  'p625': 'P-625',
  'p600': 'P-600',
  'p600z': 'P-600Z',
  'iwm' : 'IWM',
  'impp': 'IMPP',
  'coating': 'Coating',
  'manual': 'Manual',
}
export const DeviceStatusNames:any = {
  
}

export interface Project {
  id: number;
  projectNumber?: string;
  projectName?: string;
  name?: string;
  status?: 'active' | 'completed' | 'on_hold';
  startDate: string;
  endDate?: string;
}

export interface ConnectedEquipment {
  id: string;
  name: string;
  type: string;
  model: string;
  serialNumber: string;
}

/** Per-weld-machine entry from edge device `machines` array (N machines). */
export interface DeviceWeldMachine {
  BugType?: string;
  Weld_UID?: string;
  Weld_Type?: string;
  NumberOfLogs?: string;
  WeldMachineConnected?: boolean;
}

// API Response Interface
export interface DeviceApiResponse {
  id: number;
  deviceId?: string;
  status: string;
  createdAt: string;
  projectNumber: string;
  projectName: string;
  projectId: number;
  updatedAt: string;
  updatedBy: string;
  weld_uid: string | null;
  weld_uid2?: string | null;
  weld_type: string | null;
  connection_status: string | null;
  communication_status?: string | null;
  response_time?: string | null;
  weldMachineConnected?: boolean | null;
  weldMachineConnected_2?: boolean | null;
  EdgeFWVersion?: string | null;
  connectedEquipment?: ConnectedEquipment | null;
  ipAddress?: string | null;
  ip_address?: string | null;
  machines?: DeviceWeldMachine[] | null;
  set_time: {
    data: string;
    error?: string;
    by_weld_uid?: Record<string, { data?: string; error?: string }>;
  } | null;
  reset_mqtt: {
    data: string;
    error?: string;
    by_weld_uid?: Record<string, { data?: string; error?: string }>;
  } | null;
  get_time: {
    data: string;
    error?: string;
    by_weld_uid?: Record<string, { data?: string; error?: string }>;
  } | null;
  erase_logs: {
    data: string;
    error?: string;
    by_weld_uid?: Record<string, { data?: string; error?: string }>;
  } | null;
  number_of_logs: {
    data: string;
    error?: string;
    by_weld_uid?: Record<string, { data?: string; error?: string }>;
  } | null;
  number_of_logs_2?: {
    data: string;
    error?: string;
  } | null;
  password_protection: {
    data: string;
    error?: string;
  } | null;
  location: {
    data: string;
    error?: string;
    by_weld_uid?: Record<string, { data?: string; error?: string }>;
  } | null;
  weld_parameter_logs: {
    data: string;
    error?: string;
  } | null;
  deviceData?: any;
}

export interface LocationData {
  Station: string;
  BugType: string;
  BugNum: string;
}

export interface DeviceOperationByWeldUid {
  data?: string;
  error?: string;
}

export interface DeviceOperation {
  data: string;
  error?: string;
  weld_uid2_data?: string;
  weld_uid2_error?: string;
  /** Prefer this for multi-machine manual devices; keyed by Weld_UID. */
  by_weld_uid?: Record<string, DeviceOperationByWeldUid>;
  parsed?: any;
}

export interface Device {
  id: string;  // deviceId from API
  name: string; // weld_type from API
  type: DeviceType;
  status: any;//DeviceStatus;
  lastSeen: string; // updatedAt from API
  connection_status?: string; // Online/Offline status from API
  communication_status?: string; // Online/Offline status from API
  response_time?: any; // Response time from API
  weldMachineConnected?: boolean; // Weld machine connected from API
  weldMachineConnected_2?: boolean;
  EdgeFWVersion?: string; // Edge FW version from API
  connectedEquipment?: ConnectedEquipment;
  project?: Project;
  /** New multi-machine format; when absent UI falls back to weld_uid / weld_uid2. */
  machines?: DeviceWeldMachine[];
  location?: {
    data: string; // JSON string containing LocationData
    parsed?: LocationData; // Parsed location data
    by_weld_uid?: Record<string, DeviceOperationByWeldUid>;
  };
  set_time?: DeviceOperation;
  reset_mqtt?: DeviceOperation;
  get_time?: DeviceOperation;
  erase_logs?: DeviceOperation;
  number_of_logs?: DeviceOperation;
  number_of_logs_2?: DeviceOperation;
  password_protection?: DeviceOperation;
  weld_parameter_logs?: DeviceOperation;
  deviceData?: any;
  metadata: {
    ipAddress?: string;
    manufacturer: string;
    model: string;
    weldType?: string;
    weldUID?: string;
    weldUID2?: string;
    serialNumber?: string;
    installationDate: string; // createdAt from API
    firmware: string;
  };
}

export interface DeviceUpdatePayload {
  status?: DeviceStatus;
  metadata?: Partial<Device['metadata']>;
  project?: Project | null;
}

export interface DeviceBulkUpdatePayload {
  deviceIds: string[];
  update: DeviceUpdatePayload;
} 